
define(
    'Tavano.TavanoteamGA4.TTGA4.Checkout'
    , [
        'Tavano.TavanoteamGA4.TTGA4.Utils'
        , 'Backbone'
        , 'underscore'
        , 'Utils'
        , 'jQuery'
        , 'Backbone.FormView'
    ]
    , function (
        TTGA4Utils
        , Backbone
        , _
        , Utils
        , jQuery
        , BackboneFormView
    ) {
        'use strict';
        window.isPageLoaded = false;
        var ga4Checkout = {
            loadGA4Checkout: function loadGA4Checkout(container) {
                var self = this;
                this.app = TTGA4Utils.getApplication('Checkout');
                this.trackLoginRegisterGA4(container);
                container.getLayout().off('beforeAppendView', this.trackPageGA4, this);
                container.getLayout().on('beforeAppendView', this.trackPageGA4, this);
                container.getLayout().on('afterAppendView', _.debounce(this.trackAddShipInfo), this);
                container.getLayout().on('afterAppendView', this.trackAddPaymentInfoEventHandler, this);
                container.getLayout().on('afterAppendView', function () {
                    if (container.getLayout().getCurrentView().$el[0].id == 'checkout') {
                        var wizardModel = container.getLayout().getCurrentView().wizard.orderWizardModel;
                        wizardModel.cancelableOff('after:OrderWizardRouter.runStep', self.setCheckers, self);
                        wizardModel.cancelableOn('after:OrderWizardRouter.runStep', self.setCheckers, self);
                        if (container.getLayout().getCurrentView().model && container.getLayout().getCurrentView().model.get('confirmation').get('internalid')) {
                            ga4Checkout.trackPurchaseEvent(container);
                        }
                    }
                })
            },
            sendCheckoutInfo: function (container) {
                try {
                    //if (profileModel) {
                    setTimeout(function () {
                        if (SC.ENVIRONMENT.SCTouchpoint == 'checkout') {
                            var model = container.getLayout().getCurrentView().model;
                            var eventData = ga4Checkout.getTransactionItems(model);
                            var promocodes = ga4Checkout.getPromotions(model);
                            var profileModel = ga4Checkout.app.getLayout().getCurrentView().wizard.profileModel;
                            eventData['client_id'] = profileModel.get('internalid') + "";
                            if (promocodes.length > 0) {
                                eventData['coupon'] = promocodes.join(',');
                            }
                            //console.log("sendCheckoutInfo", eventData);
                            TTGA4Utils.trackCheckoutInfoGA4(eventData);
                        }
                    }, 2000);
                    //}
                } catch (e) {
                    //console.log("Redirecting to myAccount after login");
                }
            }
            , setCheckers: function () {
                window.isPageViewed = false;
                window.isPaymentAdded = false;
                window.isShipInfoAdded = false;
            }
            , trackPageGA4: function (view) {
                var curUrl = Backbone.history.fragment ? '/' + Backbone.history.fragment : '/';
                if (view.$el[0].id == 'checkout') {
                    var profileModel = view.wizard.profileModel;
                    if (!window.isPageViewed && profileModel && profileModel.get('isLoggedIn') == 'T') {
                        TTGA4Utils.trackPageViewGA4(curUrl, ga4Checkout.app, 'checkout');
                    }
                }
                else if (view.$el[0].id == "LoginRegister.View") {
                    TTGA4Utils.trackPageViewGA4(curUrl, ga4Checkout.app);
                }
            }
            , trackLoginRegisterGA4: function (container) {
                container.getLayout().on('afterAppendView', function () {
                    var loginView = container.getLayout().getCurrentView().getChildViewInstance('Login')
                        , registerView = container.getLayout().getCurrentView().getChildViewInstance('Register')
                        , guestCheckoutView = container.getLayout().getCurrentView().getChildViewInstance('CheckoutAsGuest')
                        , self = this;
                    if (loginView) {
                        var loginModel = loginView.model;
                        loginModel.on('save', function (result) {
                            var user = result.get('user')
                                , userId = user.internalid;
                            TTGA4Utils.trackLoginGA4(container, userId);
                            //console.log("Environment: " + SC.ENVIRONMENT.SCTouchpoint);
                            ga4Checkout.sendCheckoutInfo(container);
                        });
                    }
                    if (registerView) {
                        registerView.cancelableOn('after:LoginRegister.register', function () {
                            var eventData = {
                                event: "TT_sign_up"
                                , data: {
                                    method: "Web"
                                }
                            };
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push(eventData);
                            //TTGA4Utils.trackRegisterGA4(container);
                            ga4Checkout.sendCheckoutInfo(container);
                        })
                    }
                    if (guestCheckoutView) {
                        var guestCheckoutForm = guestCheckoutView.$el.find('form');
                        guestCheckoutForm.submit(function (e) {
                            var curForm = jQuery(e.currentTarget)
                                , guestEmail = curForm.find('#guest-email').val()
                                , regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                            if (guestEmail && regex.test(guestEmail)) {
                                TTGA4Utils.trackCheckoutAsGuestGA4(container);
                                ga4Checkout.sendCheckoutInfo(container);
                            }
                        })
                    }
                });
            }
            , trackAddShipInfo: function (view) {
                if (view.$el[0].id == 'checkout') {
                    var self = this
                        , model = view.model
                        , profileModel = ga4Checkout.app.getLayout().getCurrentView().wizard ? ga4Checkout.app.getLayout().getCurrentView().wizard.profileModel : {}
                        , promocodes = ga4Checkout.getPromotions(model)
                        , wizardModel = ga4Checkout.app.getLayout().getCurrentView().wizard ? ga4Checkout.app.getLayout().getCurrentView().wizard.orderWizardModel : {}
                        , continueBtn = view.$el.find('[data-action="submit-step"]')
                        , checkoutConfig = SC.CONFIGURATION.checkoutApp.checkoutSteps;
                    if (view.$el[0].id == 'checkout') {
                        var changeShipMethodBtn = view.$el.find('[data-action="select-delivery-option"]')
                            , hasShipMethodChanged = false;
                        changeShipMethodBtn.on('change', function (e) {
                            ga4Checkout.trackShipInfoAfterSetShipmethod(jQuery(e.currentTarget).val());
                            hasShipMethodChanged = true;
                        });
                        wizardModel.cancelableOn('after:OrderWizardRouter.runStep', function (res) {
                            if (!hasShipMethodChanged && !window.isShipInfoAdded && !window.isPageViewed) {
                                if (checkoutConfig == 'Standard' || checkoutConfig == 'Billing First') {
                                    if (view && view.currentStep.step_url == "shipping/address" && view.currentStep.state == 'past') {
                                        if (parseInt(model.get('shipaddress')) && model.get('shipmethod')) {
                                            ga4Checkout.trackShipInfoAfterSetShipmethod();
                                        }
                                    }
                                }
                                else {
                                    if (view && view.currentStep.state == 'past' && res !== "confirmation") {
                                        if (parseInt(model.get('shipaddress')) && model.get('shipmethod')) {
                                            ga4Checkout.trackShipInfoAfterSetShipmethod();
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            }
            , trackShipInfoAfterSetShipmethod: function (selectedmethod) {
                var model = ga4Checkout.app.getLayout().getCurrentView().model
                    , profileModel = ga4Checkout.app.getLayout().getCurrentView().wizard.profileModel
                    , shipmethod = model.get('shipmethod')
                    , shipMethods = model.get('shipmethods')
                    , shipmethodModel = selectedmethod ? shipMethods.get(selectedmethod) : shipMethods.get(shipmethod)
                    , shipmethodName = shipmethodModel ? shipmethodModel.get('name') : ''
                    , eventData = ga4Checkout.getTransactionItems(model)
                    , promocodes = ga4Checkout.getPromotions(model);
                // console.log('shipmethodModel', shipmethodModel);
                eventData['shipping_tier'] = shipmethodName;
                eventData['client_id'] = profileModel.get('internalid') + "";
                if (promocodes.length > 0) {
                    eventData['coupon'] = promocodes.join(',');
                }
                //  console.log("window.isShipInfoAdded", window.isShipInfoAdded);
                //  console.log("window.isPageViewed", window.isPageViewed);
                // if(!window.isShipInfoAdded && !window.isPageViewed)
                // {
                TTGA4Utils.trackShipInfoGA4(eventData, ga4Checkout.app);
                // }
            }
            , trackAddPaymentInfoEventHandler: function (view) {
                // console.log("view", view)
                if (view.$el[0].id == 'checkout') {
                    var model = view.model
                        , changePaymentMethodBtn = view.$el.find("[data-action='change-payment-method'] a");
                    changePaymentMethodBtn.on('click', function (e) {
                        window.isPaymentAdded = false;
                    })
                    if (model) {
                        model.cancelableOff('after:LiveOrder.addPayment', ga4Checkout.trackAddPaymentInfo, this);
                        model.cancelableOn('after:LiveOrder.addPayment', ga4Checkout.trackAddPaymentInfo, this);
                    }
                }
            }
            , trackAddPaymentInfo: function (payment_method) {
                var payment_type = payment_method.type
                    , model = ga4Checkout.app.getLayout().getCurrentView().model
                    , eventData = ga4Checkout.getTransactionItems(model)
                    , profileModel = ga4Checkout.app.getLayout().getCurrentView().wizard.profileModel
                    , promocodes = ga4Checkout.getPromotions(model)
                    , wizardModel = ga4Checkout.app.getLayout().getCurrentView().wizard.orderWizardModel;
                eventData['payment_type'] = payment_type;
                eventData['client_id'] = profileModel.get('internalid') + "";
                if (promocodes.length > 0) {
                    eventData['coupon'] = promocodes.join(',');
                }
                TTGA4Utils.trackPaymentInfoGA4(eventData, ga4Checkout.app);
            }
            , trackPurchaseEvent: function (container) {
                var self = this
                    , model = container.getLayout().getCurrentView().model
                    , profileModel = ga4Checkout.app.getLayout().getCurrentView().wizard.profileModel
                    , promocodes = ga4Checkout.getPromotions(model.get('confirmation'));
                if (model) {
                    var tranSummary = model.get('confirmation').summary || {}
                        , tranShipping = tranSummary.shippingcost || 0
                        , tranTax = tranSummary.taxtotal || 0
                        , tranId = model.get('confirmation').get('tranid') || model.get('confirmation').get('confirmationnumber') || ''
                        , confirmationData = model.get('confirmation') || {}
                        , eventData = ga4Checkout.getTransactionItems(confirmationData);
                    eventData['transaction_id'] = tranId;
                    eventData['shipping'] = tranShipping;
                    eventData['tax'] = tranTax;
                    eventData['client_id'] = profileModel.get('internalid') + "";
                    if (promocodes.length > 0) {
                        eventData['coupon'] = promocodes.join(',');
                    }
                    //console.log("profileModel", profileModel);
                    eventData['transaction_id'] = tranId;
                    eventData['shipping'] = tranShipping;
                    eventData['tax'] = tranTax;
                    eventData['client_id'] = profileModel.get('internalid') + "";
                    var enhanced_transaction = {
                        transactionId: tranId,
                        value: tranSummary.subTotal,
                        currency: SC.ENVIRONMENT.currencyCodeSpecifiedOnUrl,
                        email: profileModel.get('email'),
                        phone: profileModel.get('phone'),
                        name: profileModel.get('firstname'),
                        surname: profileModel.get('lastname'),
                        // street: customerAddress.get("addr1") || "",
                        // city: customerAddress.get("city") || "",
                        // region: customerAddress.get("state") || "",
                        // country: customerAddress.get("country") || "",
                        // postalCode: customerAddress.get("zip") || "",
                    }
                    TTGA4Utils.trackPurchaseGA4(eventData);
                    //TTGA4Utils.trackEnhancedConversion(enhanced_transaction);
                }
            }
            , getPromotions: function (model) {
                if (model) {
                    var promocodes = model.get('promocodes') || []
                        , codes = [];
                    _.each(promocodes, function (val) {
                        codes.push(val.code);
                    });
                    return codes;
                }
            }
            , getTransactionItems: function (model) {
                try {
                    if (Object.keys(model).length > 0) {
                        var tranItemsObj = {}
                            , tranItemsArr = []
                            , promocodes = ga4Checkout.getPromotions(model)
                            , lines = model.get('lines') || []
                            , tranSummary = model.get('summary') || {}
                            , self = this;
                        _.each(lines.models, function (line) {
                            var itemName = "";
                            //Use parent item name for matrix items
                            if (line.get('item').get('matrix_parent')) {
                                itemName = line.get('item').get('matrix_parent').storedisplayname2;
                            } else {
                                itemName = line.get('item').get('storedisplayname2') || line.get('item').get('displayname') || line.get('item').get('_name');
                            }
                            var itemVariant = self.getItemOptions(line)
                                , itemObj = {
                                    item_id: line.get('item').get('itemid') + ""
                                    , item_name: itemName
                                    , quantity: line.get('quantity')
                                    , price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                                    , currency: SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD'
                                };
                            if (promocodes.length > 0) {
                                itemObj['coupon'] = promocodes.join(',');
                            }
                            if (itemVariant.length > 0) {
                                itemObj['item_variant'] = itemVariant.join(',')
                            }
                            tranItemsArr.push(itemObj);
                        });
                        tranItemsObj.currency = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                        tranItemsObj.value = tranSummary.total;
                        tranItemsObj.items = tranItemsArr;
                        return tranItemsObj;
                    }
                } catch (e) {
                    //("Executing getTransactionItems...");
                }
            }
            , getItemOptions: function (item) {
                var variantsArr = []
                    , itemOptions = item.get('options') || []
                    , itemOptionsModel = itemOptions.models || [];
                _.each(itemOptionsModel, function (option) {
                    var optionsValue = option.get('value') || {};
                    variantsArr.push(optionsValue.label);
                });
                return variantsArr;
            }
        }
        return ga4Checkout;
    });
